export default __webpack_public_path__ + "static/media/3.e6077ab3.png";